import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  FieldWrappers,
  ModalHeader,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { MdClose } from "react-icons/md";

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required("Document title is required")
    .min(3, "Title must be at least 3 characters"),
});

const EditDocumentModal = ({
  handleClose,
  selectedItem,
  renameMutate,
  isRenameLoading,
}) => {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (values) => {
    renameMutate({
      id: selectedItem?.id,
      type: selectedItem?.type,
      newName: values.title,
    });
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <Title>
          {selectedItem?.type === "folder"
            ? "Rename Folder"
            : "Rename Document"}
        </Title>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          enableReinitialize
          initialValues={{
            title:
              selectedItem?.type === "folder"
                ? selectedItem?.name || ""
                : selectedItem?.title || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form className="flex flex-col h-full">
              <ScrollableContent className="flex-1">
                <Wrapper>
                  <InputGroup>
                    <Label htmlFor="title">
                      {selectedItem?.type === "folder"
                        ? "Folder Name *"
                        : "Document Title *"}
                    </Label>

                    <FieldWrappers>
                      <Field
                        id="title"
                        name="title"
                        type="text"
                        autoComplete="off"
                        placeholder={
                          selectedItem?.type === "folder"
                            ? "Enter folder name"
                            : "Enter document title"
                        }
                      />
                    </FieldWrappers>

                    {errors.title && touched.title && (
                      <ErrorMessage>{errors.title}</ErrorMessage>
                    )}
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>

              <ActionSection>
                <SideCancelBtn
                  type="button"
                  onClick={handleClose}
                  disabled={isRenameLoading}
                >
                  Cancel
                </SideCancelBtn>

                <SubmitBtn type="submit" disabled={isRenameLoading}>
                  {isRenameLoading ? "Updating..." : "Update"}
                </SubmitBtn>
              </ActionSection>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

const Container = tw.div`
bg-white
w-full
h-full
flex
flex-col
`;

const ErrorMessage = tw.div`
text-red-500
text-xs
mt-1
`;

const Title = tw.h1`
text-white
text-lg
font-medium
`;

export default EditDocumentModal;
